import React, { useState } from "react";

const COLORS = {
  primary: "bg-[#D7A19E]",
  primaryHover: "hover:bg-[#c48d8a]",
  focus: "focus:ring-[#D7A19E]",
  accent: "text-[#D7A19E]",
};

const BookAppointment = ({ onClose }) => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    date: "",
    timeSlot: "",
  });

  const [errors, setErrors] = useState({});

  // Aaj ki date (YYYY-MM-DD)
  const today = new Date().toISOString().split("T")[0];

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      if (/^\d{0,10}$/.test(value)) setForm({ ...form, [name]: value });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const isSunday = (dateStr) => new Date(dateStr).getDay() === 0;
const timeSlots = [
  "11:00 AM", "11:15 AM", "11:30 AM", "11:45 AM",
  "12:00 PM", "12:15 PM", "12:30 PM", "12:45 PM",
  "01:00 PM",

  "07:30 PM", "07:45 PM", "08:00 PM", "08:15 PM", "08:30 PM"
];

  // Aaj ke bite hue slots ko block karne ka logic
  const isTimeSlotPast = (slot) => {
    if (form.date !== today) return false;
    
    const [time, modifier] = slot.split(" ");
    let [hours, minutes] = time.split(":");
    if (hours === "12") hours = "00";
    if (modifier === "PM") hours = parseInt(hours, 10) + 12;
    
    const slotTime = new Date();
    slotTime.setHours(hours, minutes, 0, 0);
    
    return slotTime < new Date(); 
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!form.name.trim()) newErrors.name = "Name required";
    if (form.phone.length !== 10) newErrors.phone = "Invalid Phone";
    if (!form.date) newErrors.date = "Select Date";
    if (form.date && isSunday(form.date)) newErrors.date = "Closed on Sunday";
    if (!form.timeSlot) newErrors.timeSlot = "Select Time";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    // ✅ WHATSAPP LINK FIX
    const phoneNumber = "917781855269"; 
    const messageText = `*New Appointment Request*\n\n*Name:* ${form.name}\n*Phone:* ${form.phone}\n*Date:* ${form.date}\n*Time:* ${form.timeSlot}`;
    
    const encodedMessage = encodeURIComponent(messageText);
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;
    
    window.open(whatsappUrl, "_blank");
    if (onClose) onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm z-50 px-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden flex flex-col md:flex-row">
        
        {/* Left Side Panel */}
        <div className={`${COLORS.primary} hidden md:flex md:w-1/3 p-6 flex-col justify-between text-white`}>
          <div>
            <h2 className="text-2xl font-serif font-bold leading-tight">Book Your Slot</h2>
            <p className="mt-2 text-xs opacity-90">Please fill in your details to confirm the visit.</p>
          </div>
          <div className="text-[10px] opacity-70 italic font-light">Fast & Secure Booking</div>
        </div>

        {/* Right Side Form */}
        <div className="flex-1 p-6 relative">
          <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Name - Full Width */}
            <div>
              <label className="block text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">Full Name</label>
              <input type="text" name="name" value={form.name} onChange={handleChange} className="w-full border-b border-gray-200 focus:border-[#D7A19E] py-1.5 outline-none text-sm transition-colors" placeholder="Enter name" />
              {errors.name && <span className="text-red-400 text-[9px] font-bold uppercase">{errors.name}</span>}
            </div>

            {/* Date & Phone - Reduced Size Row */}
            <div className="flex gap-4">
              <div className="flex-[1.5]">
                <label className="block text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">Phone</label>
                <input type="tel" name="phone" value={form.phone} onChange={handleChange} className="w-full border-b border-gray-200 focus:border-[#D7A19E] py-1.5 outline-none text-sm transition-colors" placeholder="10 digits" />
                {errors.phone && <p className="text-red-400 text-[9px] font-bold uppercase">{errors.phone}</p>}
              </div>
              <div className="flex-1">
                <label className="block text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">Date</label>
                <input type="date" name="date" min={today} value={form.date} onChange={handleChange} className="w-full border-b border-gray-200 focus:border-[#D7A19E] py-1.5 outline-none text-xs transition-colors" />
                {errors.date && <p className="text-red-400 text-[9px] font-bold uppercase">{errors.date}</p>}
              </div>
            </div>

            {/* Time Slots Grid */}
            <div>
              <label className="block text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-2">Available Time</label>
              <div className="grid grid-cols-3 gap-1.5">
                {timeSlots.map((slot) => {
                  const past = isTimeSlotPast(slot);
                  return (
                    <button
                      key={slot}
                      type="button"
                      disabled={past}
                      onClick={() => setForm({ ...form, timeSlot: slot })}
                      className={`py-2 text-[10px] font-medium rounded transition-all ${
                        past ? "bg-gray-50 text-gray-300 cursor-not-allowed border-transparent" :
                        form.timeSlot === slot ? `${COLORS.primary} text-white shadow-sm scale-95` : "border border-gray-100 text-gray-500 hover:border-[#D7A19E]"
                      }`}
                    >
                      {slot}
                    </button>
                  );
                })}
              </div>
              {errors.timeSlot && <p className="text-red-400 text-[9px] font-bold uppercase mt-1">{errors.timeSlot}</p>}
            </div>

            <button type="submit" className={`w-full ${COLORS.primary} ${COLORS.primaryHover} text-white py-3 rounded-lg font-bold text-xs uppercase tracking-[0.2em] shadow-md transition-all active:scale-[0.97] mt-2`}>
              Confirm Appointment
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BookAppointment;